import React from 'react';
import Currencies from '../../components/AdminNext/Currencies';
import HeadLessLayout from '../../components/Layout/HeadLessLayout';

function action({ store }) {
  if (!store.getState().runtime.isAdminAuthenticated) return { redirect: '/login' };

  return {
    title: 'Currencies — Bas Recovery Admin',
    component: (
      <HeadLessLayout>
        <Currencies />
      </HeadLessLayout>
    )
  };
}

export default action;
